import {
  SHOW_LOADING,
  HIDE_LOADING,
  SET_CONFIRM,
  SET_LOADING_MSG,
  SET_LOAD_TYPE,
  SHOW_ACTION_LOADING,
  HIDE_ACTION_LOADING,
} from './types';

const initialState = {
  show: false,
  confirmed: false,
  message: '',
  loadtype: '',
  actionShow: false,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SHOW_LOADING: {
      return { ...state, show: true };
    }
    case HIDE_LOADING: {
      return { ...state, show: false };
    }
    case SET_CONFIRM: {
      return { ...state, confirmed: action.payload.confirmed };
    }
    case SET_LOAD_TYPE: {
      return { ...state, loadtype: action.payload.code };
    }
    case SET_LOADING_MSG: {
      return { ...state, ...action.payload };
    }
    case SHOW_ACTION_LOADING: {
      return { ...state, actionShow: true };
    }
    case HIDE_ACTION_LOADING: {
      return { ...state, actionShow: false };
    }
    default: return state;
  }
};

export default reducer;
